import React from 'react';
import {Col, Container, Image, Row} from 'react-bootstrap';

const Footer = () => {
    return (
        <footer className='background-color-purple footer'>
            <Container>
                <br/>
                <Row>
                    <Col>
                        Project Pierre - 2022
                    </Col>
                </Row>
                <Row>
                    <Col>

                    </Col>
                </Row>
                <br/>
            </Container>
        </footer>
    );
};

export default Footer;
